/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_02_DescInputs */

const en_landing_section_02_desc = /** @type {(inputs: Landing_Section_02_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema is built on EU-native AI infrastructure with governance controls, EU-based data processing (see Privacy Policy at /privacy for current provider and region details), and consent settings you control.`)
};

const de_landing_section_02_desc = /** @type {(inputs: Landing_Section_02_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema basiert auf europaeischer KI-Infrastruktur mit Governance-Kontrollen, EU-basierter Datenverarbeitung (aktuelle Details in der Datenschutzerklaerung /privacy) und Einwilligungseinstellungen, die du selbst steuerst.`)
};

const fr_landing_section_02_desc = /** @type {(inputs: Landing_Section_02_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema est conçu pour l'Europe — traitement IA en UE (voir /privacy pour les détails actuels sur le fournisseur et la région), contrôles de gouvernance transparents et paramètres de consentement que vous contrôlez.`)
};

const es_landing_section_02_desc = /** @type {(inputs: Landing_Section_02_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema está diseñado para Europa — procesamiento de IA en la UE (consulta /privacy para detalles actuales de proveedor y región), controles de gobernanza transparentes y ajustes de consentimiento que tú controlas.`)
};

const it_landing_section_02_desc = /** @type {(inputs: Landing_Section_02_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema è costruito per l'Europa — elaborazione IA nell'UE (vedi /privacy per i dettagli attuali su fornitore e regione), controlli di governance trasparenti e impostazioni di consenso che controlli tu.`)
};

const nl_landing_section_02_desc = /** @type {(inputs: Landing_Section_02_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema is gebouwd voor Europa — AI-verwerking in de EU (zie /privacy voor actuele details over aanbieder en regio), transparante governance-controles en toestemmingsinstellingen die jij beheert.`)
};

const pl_landing_section_02_desc = /** @type {(inputs: Landing_Section_02_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema jest zbudowane dla Europy — przetwarzanie AI w UE (patrz /privacy dla aktualnych szczegółów dotyczących dostawcy i regionu), przejrzyste kontrole zarządzania i ustawienia zgody, które kontrolujesz.`)
};

const fi_landing_section_02_desc = /** @type {(inputs: Landing_Section_02_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema on rakennettu Eurooppaa varten — tekoalykasittely EU:ssa (ajantasaiset tiedot palveluntarjoajasta ja alueesta: /privacy), laepinaekyvyys ja suostumusasetukset, joita hallitset itse.`)
};

const da_landing_section_02_desc = /** @type {(inputs: Landing_Section_02_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema er bygget til Europa — AI-behandling i EU (se /privacy for aktuelle detaljer om udbyder og region), gennemsigtige governance-kontroller og samtykkeindstillinger, som du styrer.`)
};

const sv_landing_section_02_desc = /** @type {(inputs: Landing_Section_02_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema aer byggt foer Europa — AI-behandling i EU (se /privacy foer aktuella detaljer om leverantor och region), oeppna governance-kontroller och samtyckesinstallningar som du kontrollerar.`)
};

/**
* | output |
* | --- |
* | "Alchema is built on EU-native AI infrastructure with governance controls, EU-based data processing (see Privacy Policy at /privacy for current provider and r..." |
*
* @param {Landing_Section_02_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_02_desc = /** @type {((inputs?: Landing_Section_02_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_02_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_02_desc(inputs)
	if (locale === "fr") return fr_landing_section_02_desc(inputs)
	if (locale === "es") return es_landing_section_02_desc(inputs)
	if (locale === "it") return it_landing_section_02_desc(inputs)
	if (locale === "nl") return nl_landing_section_02_desc(inputs)
	if (locale === "pl") return pl_landing_section_02_desc(inputs)
	if (locale === "fi") return fi_landing_section_02_desc(inputs)
	if (locale === "da") return da_landing_section_02_desc(inputs)
	if (locale === "sv") return sv_landing_section_02_desc(inputs)
	return en_landing_section_02_desc(inputs)
});